import React, { Dispatch, SetStateAction } from 'react'
import * as Yup from 'yup';
import { Modal, Row } from 'antd'
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui'
import { UploadMultipleTable, Visibility } from '@app/components';
import { RetornarFluxoProponentes } from '@app/api/sas/ordemCompra';
import { ordemCompraIdState, reloadVendorListState } from '../atoms'
import { useRecoilState, useRecoilValue } from 'recoil';


interface Props {
  exibirModal: boolean;
  statusAnterior: string; 
  setExibirModal: Dispatch<SetStateAction<boolean>>;
  setStatusAnterior: Dispatch<SetStateAction<string>>; 
}


const ModalRetornarFluxoProponentes = (props: Props) => {
const { exibirModal, setExibirModal, statusAnterior, setStatusAnterior } = props;



    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);

    const onCancel = () => {
        setExibirModal(false)
    }

    const onSubmit = (values: any) => {
        const form = new FormData();
        form.append('id', ordemCompraId);
        form.append('justificativa', values.justificativa);
        form.append('StatusAnterior', statusAnterior);
        RetornarFluxoProponentes(form)
            .then((data: any) => {
                if (data.valid) {
                    window.location.reload();
                    setExibirModal(false)
                }
            })
    }

    return (
        <Visibility visible={exibirModal}>

            <Modal
                title='Retornar propostas comerciais'
                width='780px'
                visible={exibirModal}
                onCancel={onCancel}
                footer={null}
            >

                <MasterDetailForm
                    key="formAprovacaoProponentesGerente"
                    onSubmit={onSubmit}
                    validationSchema={Yup.object().shape({
                        justificativa: Yup.string()
                            .required('Justificativa deve ser informado')
                            .max(2000, 'Nome deve ter no máximo 2000 caracteres')
                    })}
                    actions={[
                        <Button title='Fechar' onClick={() => onCancel()} type="link" />,
                        <FormSubmitButton noIcon type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                    ]} >
                    <Widget >
                        <Row>
                            <FormTextArea name='justificativa' label='Justificativa' span={12} rows={3} />
                        </Row>
                    </Widget>
                </MasterDetailForm>

            </Modal>

        </Visibility>
    )
}

export default ModalRetornarFluxoProponentes